module.exports = __webpack_public_path__ + "static/media/LiveAgent_HBT.4704bfb9.svg";